import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import personIcon from "../../src/assests/personIcon.svg";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../providers/auth-provider";
import BrandedLogo from "./branded-logo";
import SideBarData from "../utils/data/side-bar";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import clsx from "clsx";
import ThemeToggle from "./theme-toggle";
import {
  faAngleLeft,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { useSidebar } from "../store/use-sidebar";

export default function LeftSidebar() {
  const { user, HandleUserLogOut } = useContext(AuthContext);
  const { collapsed, toggleSidebar } = useSidebar();

  const isActive = (path: string) => {
    return window.location.pathname === path;
  };

  return (
    <div className="relative bg-surface h-full animate-fade-in-slow">
      <div className="sticky top-0 h-screen w-full border-r border-edge flex flex-col">
        <div
          className={clsx(
            "flex items-center border-b border-edge-faint transition-all duration-300 shrink-0 px-4 pt-5 pb-4",
            collapsed ? "justify-center" : "justify-between"
          )}
        >
          <div
            className={clsx(
              "flex items-center overflow-hidden transition-all duration-500 ease-out",
              collapsed
                ? "w-0 opacity-0 -translate-x-2"
                : "w-full opacity-100 translate-x-0"
            )}
          >
            <BrandedLogo className="w-[132px] shrink-0 opacity-95" />
          </div>
          <button
            type="button"
            aria-label="Toggle sidebar"
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            onClick={toggleSidebar}
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-edge bg-overlay text-light-gray hover:text-text-primary hover:border-indigo-400/40 hover:shadow-glow-sm transition-all duration-200 cursor-pointer"
          >
            <FontAwesomeIcon
              icon={faAngleLeft}
              className={clsx(
                "text-xs transition-transform duration-300",
                collapsed && "rotate-180"
              )}
            />
          </button>
        </div>

        <ul className="font-medium flex-1 overflow-y-auto overflow-x-hidden custom-scrollbar py-2">
          {SideBarData.map((item) => {
            const active = isActive(item.route);
            return (
              <div
                className={item.label === "My Customers" ? "mt-10" : ""}
                key={item.route}
              >
                <li
                  className={clsx(
                    "group relative flex gap-3 py-3 items-center transition-all duration-200 hover:bg-active-background hover:border-r-[3px] hover:border-blue",
                    collapsed ? "px-0 justify-center" : "px-6",
                    active && "border-blue bg-active-background border-r-[3px]"
                  )}
                >
                  <Link
                    to={item.route}
                    title={collapsed ? item.label : undefined}
                    className={clsx(
                      "flex items-center gap-3 min-w-0",
                      collapsed ? "justify-center" : "w-full"
                    )}
                  >
                    <div className="w-[26px] flex items-center justify-center shrink-0">
                      <FontAwesomeIcon
                        icon={item.icon as IconProp}
                        className={clsx(
                          "text-[17px] transition-colors duration-200",
                          active
                            ? "text-blue"
                            : "text-light-gray group-hover:text-blue"
                        )}
                      />
                    </div>
                    {!collapsed && (
                      <span
                        className={clsx(
                          "w-full font-medium text-nowrap text-[15px] transition-colors duration-200",
                          active
                            ? "text-text-primary"
                            : "text-light-gray group-hover:text-text-primary"
                        )}
                      >
                        {item.label}
                      </span>
                    )}
                  </Link>
                </li>

                {item?.subData?.length && !collapsed ? (
                  <ul className="ml-14 flex flex-col">
                    {item.subData.map((subItem) => (
                      <Link
                        key={subItem.route}
                        to={subItem.route}
                        className={clsx(
                          "my-3 cursor-pointer w-full font-medium text-nowrap text-[14px] text-light-gray hover:text-text-primary transition-colors duration-200",
                          isActive(subItem.route) && "!text-blue"
                        )}
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </ul>
                ) : null}
              </div>
            );
          })}
        </ul>

        <div className="shrink-0">
          <ThemeToggle collapsed={collapsed} />
          <button
            type="button"
            onClick={HandleUserLogOut}
            title={collapsed ? "Log out" : undefined}
            className={clsx(
              "group/logout w-full cursor-pointer bg-surface-elevated border-t border-edge py-3 flex items-center gap-3 transition-colors duration-300 hover:bg-active-background text-left",
              collapsed ? "px-0 justify-center" : "px-5 justify-between"
            )}
          >
            <div
              className={clsx(
                "flex items-center gap-3 min-w-0",
                collapsed && "justify-center"
              )}
            >
              <img
                className={clsx(
                  "rounded-full ring-2 ring-indigo-500/30 shrink-0",
                  collapsed ? "w-9 h-9" : "w-11 h-11"
                )}
                src={personIcon}
                alt=""
              />
              {!collapsed && (
                <div className="flex flex-col min-w-0">
                  <p className="font-medium text-[15px] text-heading-color truncate">
                    {user?.name}
                  </p>
                  <p className="font-medium text-xs text-light-gray capitalize truncate">
                    {user?.type?.replace("-", " ")}
                  </p>
                </div>
              )}
            </div>
            {!collapsed && (
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="text-light-gray group-hover/logout:text-blue text-sm shrink-0 transition-colors"
                title="Log out"
              />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
